module.exports = __webpack_public_path__ + "static/img/order-management.5d4b988.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/order-management.png
// module id = R/64
// module chunks = 1